// src/pages/CheckoutSuccessPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import Button from "../components/Button";
import "./CheckoutSuccessPage.css";
import PageHeader from "../components/PageHeader";

const CheckoutSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="checkout-success-container">
        <PageHeader 
          title={t("checkoutSuccess.title")} 
          subtitle={t("checkoutSuccess.description")}
        />
        <Button 
          label={t("checkoutSuccess.homeButton")} 
          onClick={() => navigate("/")} 
          type="button" 
        />
      </div>
    </Layout>
  );
};

export default CheckoutSuccessPage;
